import { createReducer } from '@reduxjs/toolkit';
import { open, close } from 'actionCreators/exit';

const exitReducer = createReducer(false, (builder) => {
  builder.addCase(open, () => true);
  builder.addCase(close, () => false);
});

export { exitReducer };
